import { WarningAmber } from '@mui/icons-material';
import { Alert, Box, Button, Typography } from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import messages from '../integrationMessages';

const OAUTH_INTEGRATIONS = new Set(['salesforce', 'hubspot', 'gsheets', 'slack', 'zendesk']);

function IntegrationPausedAlert({ integration, integrationName, onReauthorize }) {
  const { formatMessage } = useIntl();

  if (!integration || integration.isActive !== false) {
    return null;
  }

  const canReconnect = OAUTH_INTEGRATIONS.has(integrationName) && onReauthorize;
  const failingSince = integration.failingSince
    ? moment(integration.failingSince).format('LLL')
    : null;

  return (
    <Alert
      severity="warning"
      icon={<WarningAmber fontSize="inherit" />}
      sx={{ mb: 2, width: '100%' }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <Typography variant="body2">
          {failingSince
            ? formatMessage(messages.integrationPausedWithDate, { failingSince })
            : formatMessage(messages.integrationPaused)}
        </Typography>
        {canReconnect && (
          <Button
            variant="contained"
            size="small"
            color="warning"
            onClick={() => onReauthorize(integrationName)}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {formatMessage(messages.integrationPausedReconnect)}
          </Button>
        )}
      </Box>
    </Alert>
  );
}

IntegrationPausedAlert.propTypes = {
  integration: PropTypes.object,
  integrationName: PropTypes.string.isRequired,
  onReauthorize: PropTypes.func,
};

export default IntegrationPausedAlert;
